import { useBreadcrumbTrail } from "@/data/Content/BreadcrumbTrail";
import { ID } from "@/data/types/Basic";
import { Typography } from "@mui/material";
import { FC } from "react";

export const HeadingRv:FC<{ id: ID }> = () => {
    const breadcrumb = useBreadcrumbTrail();
    const headingText = breadcrumb?.breadcrumb?.at(-1)?.label;
    return headingText ? <Typography variant="h1" mb={0}>{headingText}</Typography> : null;
}